import React from "react";

export default function ConfirmDelete({ onConfirm, onCancel, loading }) {
  return (
    <div className="flex items-center gap-1.5 shrink-0">
      <span className="text-xs text-gray-500">Supprimer ?</span>
      <button onClick={onConfirm} disabled={loading} className="btn btn-sm btn-danger">
        {loading ? "…" : "Oui"}
      </button>
      <button onClick={onCancel} disabled={loading} className="btn btn-sm btn-secondary">
        Non
      </button>
    </div>
  );
}
